/** Standard full-screen popup form content width. */
export const POPUP_FORM_CONTENT_WIDTH_CLASS = 'w-[352px]';

/** Standard full-screen popup form content max width. */
export const POPUP_FORM_CONTENT_MAX_WIDTH_CLASS = 'max-w-[352px]';

/** Full-screen popup form shell — login, sign-up, inquiry, quote, report, etc. */
export const POPUP_FORM_CONTENT_CLASS =
  `${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto hidden-scrollbar lg:pb-0 relative`;

/** Dashboard action popup shell — settings field editors (original responsive width). */
export const ACTION_POPUP_CONTENT_CLASS =
  'w-[320px] sm:w-[380px] mx-auto hidden-scrollbar lg:pb-0 relative';

export const ACTION_POPUP_CONTENT_WIDTH_CLASS = 'w-[320px] sm:w-[380px]';

/** Wider confirmation dialog — Cancel/Save and Test/Save actions. */
export const CONFIRM_POPUP_CONTENT_WIDTH_CLASS = 'w-[400px] sm:w-[480px]';

/** Inner content spacing for action popups (below popup chrome, above fields). */
export const ACTION_POPUP_CONTENT_INNER_CLASS = 'mt-10 xl:mt-8 w-full';
